import Tooltip from "../Tooltip";
import { FormComponentType } from "./type";

const FormComponent: React.FC<FormComponentType> = ({
    children,
    name,
    label,
    required,
    formData,
    topTooltip,
    bottomTooltip,
    leftTooltip,
    rightTooltip,
    display,
}) => {
    const { error, touched } = formData.getFieldMeta(name);
    return (
        <Tooltip
            show={Boolean(touched && error)}
            content={error}
            type='error'
            side='top'
            top={topTooltip}
            bottom={bottomTooltip}
            left={leftTooltip}
            right={rightTooltip}
            display={display}
        >
            {Boolean(label) && (<label className={`${required && 'required'}`} >{label}</label>)}
            {children}
        </Tooltip>
    );
};

export default FormComponent;